export class ApiError extends Error { constructor(message: string, public status: number) { super(message); } }

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    credentials: "same-origin",
    ...init,
    headers: { ...(init.body ? { "Content-Type": "application/json" } : {}), ...(init.headers || {}) }
  });
  const type = response.headers.get("content-type") || "";
  const body = type.includes("application/json") ? await response.json() : await response.text();
  if (!response.ok) throw new ApiError(body?.error || body || `Request failed: ${response.status}`, response.status);
  return body as T;
}
